/**
 * Minimum Order Progress Bar
 * Handles dynamic updates for minimum order requirement ($100)
 * Modern design with responsive support
 */

(function() {
  var MINIMUM_ORDER_AMOUNT = 10000; // $100.00 in cents

  // Format money
  function formatMoney(cents) {
    if (typeof cents === 'undefined' || cents === null || isNaN(cents)) {
      console.warn('formatMoney received invalid value:', cents, 'type:', typeof cents);
      return '$0.00';
    }
    // Ensure it's a number
    cents = parseInt(cents, 10);
    if (isNaN(cents)) {
      console.warn('formatMoney could not parse cents:', cents);
      return '$0.00';
    }
    var dollars = (cents / 100).toFixed(2);
    return '$' + dollars;
  }

  // Update progress bar on cart page
  function updateCartProgressBar(cartTotal) {
    var sectionElement = document.getElementById('minimum-order-section');
    if (!sectionElement) return;

    var remainingAmount = MINIMUM_ORDER_AMOUNT - cartTotal;
    var progressPercentage = Math.floor((cartTotal / MINIMUM_ORDER_AMOUNT) * 100);
    
    if (progressPercentage > 100) progressPercentage = 100;
    if (progressPercentage < 0) progressPercentage = 0;

    // Always show section
    sectionElement.classList.remove('is-hidden');
    
    // Update current cart total
    var currentTotalEl = document.getElementById('current-cart-total');
    if (currentTotalEl) {
      currentTotalEl.textContent = formatMoney(cartTotal);
    }

    // Update progress bar
    var progressBar = document.getElementById('progress-bar');
    if (progressBar) {
      progressBar.style.width = progressPercentage + '%';
    }

    var messageEl = document.getElementById('minimum-order-message');
    var successEl = document.getElementById('minimum-order-success');

    if (remainingAmount > 0) {
      // Show warning message, hide success
      if (messageEl) {
        messageEl.style.display = 'block';
        var remainingAmountEl = document.getElementById('remaining-amount');
        if (remainingAmountEl) {
          remainingAmountEl.textContent = formatMoney(remainingAmount);
        }
      }
      if (successEl) successEl.style.display = 'none';

      // Disable checkout button
      var checkoutBtns = document.querySelectorAll('.checkout--btn');
      checkoutBtns.forEach(function(btn) {
        btn.disabled = true;
        btn.title = 'Minimum order value is $100.00';
      });
    } else {
      // Show success message, hide warning
      if (messageEl) messageEl.style.display = 'none';
      if (successEl) successEl.style.display = 'block';
      
      // Enable checkout button
      var checkoutBtns = document.querySelectorAll('.checkout--btn');
      checkoutBtns.forEach(function(btn) {
        btn.disabled = false;
        btn.title = '';
      });
    }
  }

  // Update progress bar in popup modal
  function updatePopupProgressBar(cartTotal) {
    var popupElement = document.getElementById('popup-minimum-order');
    if (!popupElement) {
      //console.log('Popup element not found');
      return;
    }

    var remainingAmount = MINIMUM_ORDER_AMOUNT - cartTotal;
    var progressPercentage = Math.floor((cartTotal / MINIMUM_ORDER_AMOUNT) * 100);
    
    if (progressPercentage > 100) progressPercentage = 100;
    if (progressPercentage < 0) progressPercentage = 0;

    //console.log('Updating popup - Cart Total:', cartTotal, 'Remaining:', remainingAmount, 'Progress:', progressPercentage + '%');

    // Always show popup section
    popupElement.style.display = 'block';
    
    // Update current cart total
    var cartTotalEl = document.getElementById('popup-cart-total');
    if (cartTotalEl) {
      cartTotalEl.textContent = formatMoney(cartTotal);
    }

    // Update progress bar
    var progressBar = document.getElementById('popup-progress-bar');
    if (progressBar) {
      progressBar.style.width = progressPercentage + '%';
    }

    var messageEl = document.getElementById('popup-minimum-order-message');
    var successEl = document.getElementById('popup-minimum-order-success');

    if (remainingAmount > 0) {
      // Show warning message, hide success
      if (messageEl) {
        messageEl.style.display = 'block';
        var remainingAmountEl = document.getElementById('popup-remaining-amount');
        if (remainingAmountEl) {
          remainingAmountEl.textContent = formatMoney(remainingAmount);
        }
      }
      if (successEl) successEl.style.display = 'none';
    } else {
      // Show success message, hide warning
      if (messageEl) {
        messageEl.style.display = 'none';
        if (successEl) successEl.style.display = 'block';
      }
    }
  }

  // Get FRESH cart data via POST (POST responses are never cached by browsers)
  function getFreshCartData(callback) {
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: { updates: {} },
      dataType: 'json',
      success: function(cart) {
       // console.log('Fresh cart data via POST:', cart);
        var cartTotal = 0;
        
        if (cart.total_price && cart.total_price > 0) {
          cartTotal = parseInt(cart.total_price, 10);
        } else if (cart.items && cart.items.length > 0) {
          cart.items.forEach(function(item) {
            var itemPrice = parseInt(item.price, 10) || parseInt(item.final_price, 10) || 0;
            var itemQty = parseInt(item.quantity, 10) || 0;
            cartTotal += (itemPrice * itemQty);
          });
        }
        
        callback(cartTotal);
      },
      error: function() {
        console.error('POST /cart/update.js failed, falling back to GET');
        $.getJSON('/cart.js', function(cart) {
          callback(cart.total_price || 0);
        });
      }
    });
  }

  // Refresh both progress bars with fresh data
  function refreshCartData() {
    getFreshCartData(function(cartTotal) {
      updateCartProgressBar(cartTotal);
      updatePopupProgressBar(cartTotal);
    });
  }

  /**
   * GLOBAL CART INTERCEPTORS
   * Listens directly to Shopify API updates via both jQuery AJAX and modern Fetch API.
   * This guarantees your progress bar updates regardless of how the theme triggers the cart add.
   */

  // 1. Hook into jQuery AJAX Success Event
  if (typeof jQuery !== 'undefined') {
    $(document).ajaxSuccess(function(event, xhr, settings) {
      if (settings.url && (
        settings.url.indexOf('/cart/add') !== -1 || 
        settings.url.indexOf('/cart/update') !== -1 || 
        settings.url.indexOf('/cart/change') !== -1 ||
        settings.url.indexOf('/cart/clear') !== -1
      )) {
       // console.log('Cart updated via jQuery AJAX. Syncing progress bar...');
        // A short 400ms delay avoids race conditions with Shopify database commits
        setTimeout(refreshCartData, 400); 
      }
    });
  }

  // 2. Hook into Native Fetch API (Fallback for modern theme components / sticky bars)
  var originalFetch = window.fetch;
  if (originalFetch) {
    window.fetch = function() {
      return originalFetch.apply(this, arguments).then(function(response) {
        if (response && response.url && (
          response.url.indexOf('/cart/add') !== -1 ||
          response.url.indexOf('/cart/update') !== -1 ||
          response.url.indexOf('/cart/change') !== -1 ||
          response.url.indexOf('/cart/clear') !== -1
        )) {
         // console.log('Cart updated via Fetch API. Syncing progress bar...');
          setTimeout(refreshCartData, 400);
        }
        return response;
      });
    };
  }

  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshCartData);
  } else {
    refreshCartData();
  }

  // Refresh when cart is updated
  document.addEventListener('cartUpdated', refreshCartData);

  // Make function globally available
  window.refreshMinimumOrderProgress = refreshCartData;
})();